import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const user = {
    state: {
      userId:'',
      token: ''
    },
  
    mutations: {
      SET_TOKEN: (state, token) => {
        state.token = token
      }
    },
  
    actions: {
      SetToken ({ commit }, token) {
        return new Promise((resolve) => {
            Vue.ls.set(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', token)
            resolve()
        })
      }
  
    }
  }
  
  export default user